import { NgModule } from '@angular/core';
import { AmazingTimePickerService } from './amazing-time-picker.service';

@NgModule({
  providers: [AmazingTimePickerService]
})
export class AmazingTimePickerModule {}
